/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.0.0
 */

import clone from 'lodash/clone';
import map from 'lodash/map';

import { PagePanelButtonSelectStyled } from '../../../components/common/PageTitle/styled/PageTitleStyled';
import Select, { IOptionItemProps } from '../../../components/common/Select/Select';
import { initTranslation } from '../../internationalization/constants';
import { ICommonTranslation } from '../../internationalization/types';

export interface IExportButtonSelect {
    disabled?: boolean;
    exportExtensions: string[];
    onSelectHandler: (v: IOptionItemProps) => void;
    translation: ICommonTranslation;
}

const selectedOption = {
    label: '',
    value: '',
};

/**
 * The export button and a list of formats for select
 * @param props
 * @constructor
 */
export const ExportButtonSelect = (props: IExportButtonSelect) => {
    /**
     * selectedOption should be freeze
     */
    const getSelectedOption = () => {
        return clone(selectedOption);
    };

    const getOptions = () => {
        return map(props.exportExtensions, (ext: string) => ({
            label: ext,
            value: ext,
        }));
    };

    return <PagePanelButtonSelectStyled>
        <Select
            disabled={props.disabled}
            kind="normal"
            options={getOptions()}
            placeholder={props.translation.export.export}
            selectedOption={getSelectedOption()}
            translation={props.translation}
            onSelect={props.onSelectHandler}
        />
    </PagePanelButtonSelectStyled>;
};

ExportButtonSelect.defaultProps = {
    translation: initTranslation.common,
};

export default ExportButtonSelect;
